module.exports = __webpack_public_path__ + "img/page-active-title.a0f787b1.png";